module.exports = __webpack_public_path__ + "img/image_part_004.b31eeecd.jpg";